<template>
  <div class="quantity-input-widget">
    <button class="btn btn-minus" @click="decreaseValue()">-</button>
    <input
      type="number"
      :disabled="disabled"
      v-model="quantity"
      class="widget_quantity"
      @change="onChange"
      @blur="onBlur"
      @focus="onFocus"
      @keyup="onKeyup"
      @keydown="onKeydown"
      @click="onClick"
    />
    <button class="btn btn-plus" @click="increaseValue()">+</button>
  </div>
</template>

<script>
export default {
  name: "widget_quantity",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 900,
    },
    min: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      quantity: 1,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.quantity = vm.min;
  },
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("change", e);
    },
    onBlur(e) {
      let vm = this;
      vm.$emit("blur", e);
    },
    onFocus(e) {
      let vm = this;
      vm.$emit("focus", e);
    },
    onKeyup(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onKeydown(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
    decreaseValue() {
      let vm = this;
      if (parseInt(vm.quantity) > vm.min) {
        vm.quantity = parseInt(vm.quantity) - 1;
      }
    },
    increaseValue() {
      let vm = this;
      if (parseInt(vm.quantity) < vm.max) {
        vm.quantity = parseInt(vm.quantity) + 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.quantity-input-widget {
  display: flex;
  align-items: center;
  .btn {
    height: 35px;
    width: 35px;
    background: #f8f9fa;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .widget_quantity {
    height: 35px;
    border-radius: 5px;
    font-weight: 500;
    width: 30px;
    position: relative;
    background: #fff;
    border: none;
    outline: none;
    border-color: #c3cad9;
    margin: 0px 10px;
    text-align: center;
    -moz-appearance: textfield;
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
